import script from "./ServicesTopComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./ServicesTopComponent.vue?vue&type=script&setup=true&lang=js"

import "./ServicesTopComponent.vue?vue&type=style&index=0&id=49578a0f&scoped=true&lang=css"

import exportComponent from "D:\\2026\\frontend-rsmelinda2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49578a0f"]])

export default __exports__